import config from '~/config';

export const navItemsMobile = [
    {
        id: 1,
        title: 'Home',
        path: config.routes.home,
    },
    // {
    //     id: 2,
    // title: 'About us',
    //     path: '/ve-chung-toi',
    // },
    {
        id: 3,
        title: 'Service',
        path: config.routes.spa,
    },
    {
        id: 4,
        title: 'Product',
        path: config.routes.products,
    },
    {
        id: 5,
        title: 'Recharge card',
        path: config.routes.topUp,
    },
    // {
    //     id: 5,
    //     title: 'Blog',
    //     path: '/blog',
    // },
    // {
    //     id: 6,
    // title: 'Contact',
    //     path: config.routes.contact,
    // },
    {
        id: 7,
        title: 'Sign in',
        path: config.routes.login,
    },
];
